import { makeStyles } from "@material-ui/core/styles";

import { T } from "../../constants";

/* The row shape every column of the live board shares. */
export const useRowStyles = makeStyles({
  list: { margin: 0, padding: 0, listStyle: "none" },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    width: "100%",
    boxSizing: "border-box",
    padding: "13px 20px",
    borderTop: `1px solid ${T.borderSoft}`,
    background: "transparent",
    border: "none",
    borderTopStyle: "solid",
    textAlign: "left",
    fontFamily: "inherit",
    cursor: "pointer",
    transition: "background .15s ease",
    "&:hover": { background: T.surface },
    "&:focus-visible": { outline: `2px solid ${T.primary}`, outlineOffset: -2 },
  },
  main: { minWidth: 0, flex: 1 },
  line: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    minWidth: 0,
    fontSize: 14,
    fontWeight: 500,
    color: T.fg,
  },
  name: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  meta: {
    marginTop: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: 12,
    color: T.mutedFg,
  },
  attention: { marginTop: 2, fontSize: 12, fontWeight: 500, color: T.fg },
  critical: { marginTop: 2, fontSize: 12, fontWeight: 600, color: T.danger },
  right: {
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 3,
    textAlign: "right",
    whiteSpace: "nowrap",
    fontSize: 12,
    color: T.mutedFg,
  },
  eyebrow: {
    fontSize: 10,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: T.subtleFg,
    fontWeight: 600,
  },
  strong: { fontSize: 12, color: T.fg },
  status: { fontSize: 13, fontWeight: 500, color: T.primary },
  /* A word about the row rather than a value in it: paid, unpaid, an estimate. */
  quiet: {
    fontSize: 10,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    fontWeight: 700,
    color: T.mutedFg,
  },
  note: { fontSize: 12, color: T.mutedFg },
  actions: { flexShrink: 0, display: "inline-flex", gap: 6, alignItems: "center" },
  tiny: { padding: "5px 10px", fontSize: 12 },
  /* The row's own verb, carried by the text rather than by a filled button:
     three columns of filled buttons would read as three calls to action. */
  claim: {
    border: "none",
    background: "transparent",
    color: T.primary,
    fontSize: 13,
    fontWeight: 500,
    cursor: "pointer",
    fontFamily: "inherit",
    padding: "4px 6px",
    "&:hover": { textDecoration: "underline" },
    "&:disabled": { color: T.subtleFg, cursor: "not-allowed" },
  },
  loadMore: {
    borderTop: `1px solid ${T.borderSoft}`,
    padding: "12px 20px",
    textAlign: "center",
  },
});
